import { render } from "./IconFire.vue?vue&type=template&id=5602cd3a"
import script from "./IconFire.vue?vue&type=script&lang=js"
export * from "./IconFire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__